import ACSkeletonBox from 'academy-common-lib/components/loading/ACSkeletonBox';
import { jsx as _jsx } from "react/jsx-runtime";
const randomWidthLookup = ['100%', '95%', '85%'];
export const SkeletonGroup = ({
  rows,
  className,
  variableWidth = false
}) => {
  const boxes = [];
  for (let i = 0; i < rows; i++) {
    const randomIndex = Math.floor(Math.random() * 3);
    boxes.push( /*#__PURE__*/_jsx(ACSkeletonBox, {
      animated: true,
      className: "m-bottom-2",
      style: {
        height: '17px',
        width: variableWidth ? randomWidthLookup[randomIndex] : '100%'
      }
    }, `${i}${randomIndex}`));
  }
  return /*#__PURE__*/_jsx("section", {
    className: className,
    children: boxes
  });
};